import styled from 'styled-components'

const Wrapper = styled.nav`
    box-shadow: 0 1px 0px 0px rgba(0, 0, 0, 0.1);
    padding-top: 10px;
    padding-bottom: 10px;

    display: flex;
    align-items: center;
    justify-content: center;

    .logo {
        display: flex;
        align-items: center;
        height: 75px;
    }
`
export default Wrapper